module.exports = __webpack_public_path__ + "img/water_elemental_small.f6f7a57a.png";